import React from 'react';
import { motion } from 'framer-motion';
export function SocialProof() {
  const stats = [{
    value: '+500',
    label: 'Hombres entrenando'
  }, {
    value: '4 + 4',
    label: 'Tomos + Bonos'
  }, {
    value: '4.9/5 ⭐',
    label: 'calificación'
  }, {
    value: '🇦🇷 ARGENTINA',
    label: 'Todo el país'
  }];
  return <section className="py-8 border-y border-dark-border bg-dark-card/50 pt-[19px] pb-[19px]" data-id="element-266">
      <div className="max-w-6xl mx-auto px-4" data-id="element-267">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-268">
          {stats.map((stat, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex flex-col items-center" data-id="element-269">
              <span className="md:text-3xl font-black text-white mb-1 text-[20px]" data-id="element-270">
                {stat.value}
              </span>
              <span className="text-sm text-brand font-medium uppercase tracking-wider" data-id="element-271">
                {stat.label}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}